export function normalizeProgram(raw = {}) {
  return {
    id: Number(raw.id),
    name: raw.name || '',
    description: raw.description || '',
    price: Number(raw.price) || 0,
    much_for: raw.much_for || '',
    video: Boolean(raw.video),
    genre: raw.genre || '',
    files: raw.files || [],
    features: raw.features || [],
    crowds: raw.crowds || [],
    timings: raw.timings || [],
    types: raw.types || []
  };
}

export function isProgram(obj) {
  return obj && typeof obj === 'object' && 'id' in obj && typeof obj.name === 'string';
}

export default { normalizeProgram, isProgram };